import {
  FilterDropdownButton,
  type FilterOption,
} from "Infrastructure/Components/Forms/Buttons/FilterDropdownButton";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Stack, Typography } from "@mui/material";

export const TitleWithFilter = <T extends string = string>({
  title,
  options,
  value,
  onChange,
}: {
  title: string;
  options: FilterOption<T>[];
  value: T;
  onChange: (value: T) => void;
}) => {
  const { t } = useResource();

  return (
    <Stack direction="row" alignItems="center" width="100%">
      <Typography variant="subtitle1" fontWeight="bold" flex={1}>
        {title}
      </Typography>
      <FilterDropdownButton
        options={options}
        selectedValue={value}
        onSelectionChange={onChange}
        placeholder={t(Resources.RequestCards.Filters.ShowAll)}
      />
    </Stack>
  );
};
